export default __webpack_public_path__ + "static/media/logo-ohm.7906d39b.svg";